import { render, staticRenderFns } from "./EmailItem.vue?vue&type=template&id=3c788fb5&scoped=true&"
import script from "./EmailItem.vue?vue&type=script&lang=js&"
export * from "./EmailItem.vue?vue&type=script&lang=js&"
import style0 from "./EmailItem.vue?vue&type=style&index=0&id=3c788fb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c788fb5",
  null
  
)

export default component.exports